import apiClient from '../apiClient'

export const fetchPaymentStatusBySberOrderId = async (id: string) => {
  const { data } = await apiClient.post('/api/pay/check', {
    order_id: id,
  })
  return data
}
